import { put } from 'redux-saga/effects';

import { callHttp } from '../utils/api';
import { post } from '../utils/httpUtil';
import { SEND_PROFILE_CHANGES } from '../constants/api';
import { setError } from '../actions';
import { enqueueSnackbar } from '../actions/snackbar';

export function* sendProfileChanges({ payload: { type, ...values } }) {
  try {
    yield callHttp(post, SEND_PROFILE_CHANGES(type, values), {});
    return yield put(
      enqueueSnackbar({
        message: 'Daten gespeichert',
        options: {
          variant: 'success'
        }
      })
    );
  } catch (err) {
    yield put(setError(err));
    return yield put(
      enqueueSnackbar({
        message: 'Fehler. Bitte noch mal versuchen.',
        options: {
          variant: 'error'
        }
      })
    );
  }
}
